<template>
  <transition name="fade">
    <div v-if="isLoading" class="loading-bar-container">
      <div class="loading-bar"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loading",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.loading-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 9999;
}

.loading-bar {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: var(--bjp-gold-200);
}

.loading-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, var(--bjp-gold-600), var(--bjp-petrol-700));
  animation: indeterminate-progress 1.5s linear infinite;
}

@keyframes indeterminate-progress {
  0% {
    left: -35%;
    right: 100%;
    width: 35%;
  }
  60% {
    left: 100%;
    right: -90%;
    width: 55%;
  }
  100% {
    left: 100%;
    right: -90%;
    width: 55%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
